/** Reports > Packaging: the legacy packaging reports as one list (user, 2026-10-22). */
import { reportPermissionsOf } from "@nexseed/shared";
import { createFileRoute, redirect } from "@tanstack/react-router";
import { useAuth } from "@/features/auth/store";
import { PackagingReportsIndexPage } from "@/features/packaging/reports/packaging-reports-pages";

export const Route = createFileRoute("/_app/reports/packaging/")({
  // Any Packaging report's own code opens the list.
  beforeLoad: () => {
    const { can } = useAuth.getState();
    if (!reportPermissionsOf("packaging").some((c) => can(c)))
      throw redirect({ to: "/reports" });
  },
  component: PackagingReportsIndexPage,
});
